var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7933 1.33301H5.20665C2.77998 1.33301 1.33331 2.77967 1.33331 5.20634V10.7863C1.33331 13.2197 2.77998 14.6663 5.20665 14.6663H10.7866C13.2133 14.6663 14.66 13.2197 14.66 10.793V5.20634C14.6666 2.77967 13.22 1.33301 10.7933 1.33301ZM11.2133 9.49301L8.35331 12.353C8.25998 12.4463 8.13331 12.4997 7.99998 12.4997C7.86665 12.4997 7.73998 12.4463 7.64665 12.353L4.78665 9.49301C4.59331 9.29967 4.59331 8.97967 4.78665 8.78634C4.97998 8.59301 5.29998 8.59301 5.49331 8.78634L7.49998 10.793V3.99967C7.49998 3.72634 7.72665 3.49967 7.99998 3.49967C8.27331 3.49967 8.49998 3.72634 8.49998 3.99967V10.793L10.5066 8.78634C10.7 8.59301 11.02 8.59301 11.2133 8.78634C11.3133 8.88634 11.36 9.01301 11.36 9.13967C11.36 9.26634 11.3066 9.39967 11.2133 9.49301Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.46297f6a22ec15b43423f873026a0377.svg";
export { ForwardRef as ReactComponent };